Vue.component("profilestatic", {
  props: {
    featured: {
      type: Array
    },
    districtdata: {
      type: Object
    },
    staffingData: {
      type: Array
    },
    staffingData17: {
      type: Array
    }
  },
  mounted() {
    this.setListeners();
  },
  data() {
    return {
      activeYear: "2023-24",
      profileData: {},
      isloaded: false,
      librarianData: false
    };
  },
  computed: {
    featuredName() {
      return this.districtdata[this.featured[0]].agency_name;
    },
    featuredClass() {
      if (this.featured.length == 0 || Object.keys(this.districtdata).length == 0) {
        return "";
      }
      let len = this.districtdata[this.featured[0]].agency_name.length;
      if (len > 40) {
        return "featuredSmaller";
      }
      return "";
    },
    featuredState() {
      if (this.featured.length == 0 || Object.keys(this.districtdata).length == 0) {
        return false;
      }
      return this.districtdata[this.featured[0]].StAbr;
    },
    numSchools() {
      if (!this.profileData || !this.profileData.filter) {
        return false;
      }
      let stud = this.profileData.filter((item) => {
        return item.data_field_id == 1;
      });
      if (stud.length == 0) {
        return false;
      }
      return stud[0].data_value;
    },
    numSchoolsFormatted() {
      if (!this.numSchools) {
        return false;
      }
      return formatSlideData(this.numSchools, "Number");
    },
    numStudents() {
      if (!this.profileData || !this.profileData.filter) {
        return false;
      }
      let stud = this.profileData.filter((item) => {
        return item.data_field_id == 5;
      });
      if (stud.length == 0) {
        return false;
      }
      return stud[0].data_value;
    },
    numStudentsFormatted() {
      if (!this.numStudents) {
        return false;
      }
      return formatSlideData(this.numStudents, "Number");
    },
    numLibrarians() {
      if (!this.profileData || !this.profileData.filter) {
        return false;
      }
      let stud = this.profileData.filter((item) => {
        return item.data_field_id == 20;
      });
      if (stud.length == 0) {
        return false;
      }
      return stud[0].data_value;
    },
    numLibrariansFormatted() {
      if (!this.numLibrarians) {
        return false;
      }
      return formatSlideData(this.numLibrarians, "Number");
    },
    numTeachers() {
      if (!this.profileData || !this.profileData.filter) {
        return false;
      }
      let stud = this.profileData.filter((item) => {
        return item.data_field_id == 16;
      });
      if (stud.length == 0) {
        return false;
      }
      return stud[0].data_value;
    },
    numTeachersFormatted() {
      if (!this.numTeachers) {
        return false;
      }
      return formatSlideData(this.numTeachers, "Number");
    },
    numLibsPerSchool() {
      if (!this.numLibrarians || !this.numSchools) {
        return false;
      }
      if (this.numSchools == 0) {
        return "(n/a)";
      }
      return formatSlideData(this.numLibrarians / this.numSchools, "Number2");
    },
    numStudentsPerLib() {
      if (!this.numLibrarians || !this.numStudents) {
        return false;
      }
      if (this.numLibrarians == 0) {
        return "(n/a)";
      }
      return formatSlideData(this.numStudents / this.numLibrarians, "Number");
    },
    numTeachersperLibrarian() {
      if (!this.numLibrarians || !this.numTeachers) {
        return false;
      }
      if (this.numLibrarians == 0) {
        return "(n/a)";
      }
      return formatSlideData(this.numTeachers / this.numLibrarians, "Number");
    },
    sortedData() {
      return this.staffingData;
    },

    libTrendData() {
      if (!this.librarianData) {
        return [];
      }
      let libTrendArray = [];
      let libTrendDataArray = [];

      const parseTime = d3.timeParse("%Y");

      for (let i = 0; i < this.librarianData.length; i++) {
        let thisDateArray = this.librarianData[i].data_year.split("-");
        let thisDate = thisDateArray[0];
        let libTrendDataItem = {
          // date: parseTime(d.date),
          date: parseTime(thisDate),
          value: this.librarianData[i].data_value * 1
        };
        libTrendDataArray.push(libTrendDataItem);
      }
      libTrendDataArray.sort((a, b) => a.date - b.date);

      let libTrendObject = {
        Label: "Librarian FTEs",
        Data: libTrendDataArray
      };
      libTrendArray.push(libTrendObject);

      return libTrendArray;
    }
  },
  methods: {
    async savePDF() {
      let profileWrapper = document.getElementById("profile-static-wrapper");
      profileWrapper.classList.remove("web");
      // DOCUMENTATION: https://ekoopmans.github.io/html2pdf.js/
      var element = document.getElementById("profile-static-wrapper");
      opt = {
        margin: 0,
        filename: "district profile.pdf",
        image: { type: "jpeg", quality: 0.98 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
        html2canvas: {
          scale: 1,
          scrollY: 0,

          onclone: (element) => {
            const svgElements = Array.from(element.querySelectorAll("svg"));
            svgElements.forEach((s) => {
              const bBox = s.getBBox();
              s.setAttribute("x", bBox.x);
              s.setAttribute("y", bBox.y);
              s.setAttribute("width", bBox.width);
              s.setAttribute("height", bBox.height);
            });
            // const imgElements = Array.from(element.querySelectorAll('img'));
            // imgElements.forEach(s => {
            //     const bBox = s.getBBox();
            //     // s.setAttribute("x", bBox.x);
            //     // s.setAttribute("y", bBox.y);
            //     s.setAttribute("width", bBox.width);
            //     s.setAttribute("height", bBox.height);
            // })
          }
        }
      };
      await html2pdf().set(opt).from(element).save();
      profileWrapper.classList.add("web");
    },
    setListeners() {
      let $this = this;
      bus.$on("setStaticProfileData", (data) => {
        $this.profileData = data;
      });
      bus.$on("setStaticProfileLibrarianData", (data) => {
        $this.librarianData = data;
        $this.$nextTick(function () {
          $this.isloaded = true;
        });
      });
    }
  }
});
